<!--
  --
  -- 予約系のページヘッダ
  --
  -->
<template>
  <h1 class="text-h6 mb-4"><slot/></h1>
</template>

<script>
export default {
  name: 'CBookHeader'
}
</script>
